const options = {
  5: "bg-rose-600/5",
  10: "bg-rose-600/10",
  25: "bg-rose-600/25",
  50: "bg-rose-600/50",
  75: "bg-rose-600/75",
  90: "bg-rose-600/90",
  100: "bg-rose-600",
};

const from = {
  5: "from-rose-600/5",
  10: "from-rose-600/10",
  25: "from-rose-600/25",
  50: "from-rose-600/50",
  75: "from-rose-600/75",
  90: "from-rose-600/90",
  100: "from-rose-600",
};

export default function getBackgroundRose600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
